import { Ng2StateDeclaration } from '@uirouter/angular';
import { removeDomainResolver } from '@client/app/shared-modules/state/state-resolvers/remove-domain-resolver';
import { isCustomerAdminResolver } from '@client/app/shared-modules/state/state-resolvers/is-customer-admin-resolver';
import { AdminLayoutComponent } from '@client/app/feature-modules/admin/components/admin-layout/admin-layout.component';
import { Transition } from '@uirouter/core';
import { TopMenuService } from '@client/app/layout/menu/top-menu.service';

export const AdminStates: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.admin',
        url: '/admin',
        data: {
            usesModernStyles: true,
            // No shellPath here: this is a layout wrapper — '/admin' is owned by
            // base.customer.admin.dashboard so shell navigation lands on content.
        },
        resolve: [
            isCustomerAdminResolver(),
            removeDomainResolver(),
        ],
        component: AdminLayoutComponent,
        onEnter: (transition: Transition) => {
            const injector = transition.injector();
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const topMenuService = injector.get(TopMenuService);
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
            topMenuService.setAdminRoute(true);
        },
        onExit: (transition: Transition) => {
            const injector = transition.injector();
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const topMenuService = injector.get(TopMenuService);
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
            topMenuService.setAdminRoute(false);
        },
    },
];
